import { ReactElement } from 'react'
import { useRouter } from 'next/router'
import useUser, { isAuthorizedUser } from 'shared/hooks/use-user'
import { DomainAssetsInterface } from 'shared/types/domain'
import { baseServerSideProps } from 'shared/utils/base-server-side-props'
import { WithCustomDomainResult, withCustomDomain } from 'shared/utils/with-custom-domain'
import { withDomainAssets } from 'shared/utils/with-domain-assets'
import { getAuthenticationLayout } from 'modules/authentication/layout/get-auhentication-layout'
import { LoginForm } from 'modules/authentication/login/components/login-form'
import { LoginFormDashboard } from 'modules/authentication/login/components/login-form-dashboard'

const Login = ({ hasCustomDomain }: WithCustomDomainResult) => {
  const { user } = useUser()
  const router = useRouter()
  if (isAuthorizedUser(user)) {
    const redirectUrl = hasCustomDomain ? '/community' : '/dashboard'
    router.push(redirectUrl, redirectUrl, { locale: false })
  }
  return hasCustomDomain ? <LoginForm hasCustomDomain={hasCustomDomain} /> : <LoginFormDashboard />
}

export const getServerSideProps = withCustomDomain(withDomainAssets(baseServerSideProps))

Login.getLayout = (
  page: ReactElement,
  props: { domainAssets?: DomainAssetsInterface } & WithCustomDomainResult,
) =>
  getAuthenticationLayout(page, {
    titleKey: 'security.login.page_title',
    domainAssets: props.domainAssets,
    hasCustomDomain: props.hasCustomDomain,
  })

export default Login
